module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("List of Maps and Diagrams")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 1")]), _vm._v(" Trade routes through Ancient Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 2")]), _vm._v(" The City of David on the Ophel")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 3")]), _vm._v(" Extension of the city onto Mt Moriah")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 4")]), _vm._v(" Palestine’s Separate Kingdoms (late tenth century bce)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 5")]), _vm._v(" Kings of Judah and Israel during the early and mid-ninth century bce")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 6")]), _vm._v(" Hezekiah’s late eighth century bce expansion onto Jerusalem’s Western Hill")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 7")]), _vm._v(" Palestine c.701 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 8")]), _vm._v(" Josiah and his successors")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 9")]), _vm._v(" Zerubbabel’s Davidic lineage")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 10")]), _vm._v(" Nehemiah’s Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 11")]), _vm._v(" The Seleucid kings 321–164 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 12")]), _vm._v(" The Sons of Mattathias Asamonaeus")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 13")]), _vm._v(" The Seleucid kings 223–125 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 14")]), _vm._v(" The Hasmonean Dynasty")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 15")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The First Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 16")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Second Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 17")]), _vm._v(" Herod’s family (excluding his children and their mothers)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 18")]), _vm._v(" Herod’s Jerusalem c.18 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 19")]), _vm._v(" Herod II (the Great) 72–4 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(" His children, their mothers and selected offspring")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 20")]), _vm._v(" Jerusalem c.70 ce")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 21")]), _vm._v(" Aelia Capitolina")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("Figure 22")]), _vm._v(" Jerusalem’s Byzantine churches x")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-576f5956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List.vue
// module id = 75
// module chunks = 0